import CareerSection from "../../Components/CarrepageSection/Carrersection";
import PageBanner from "../../layout/Banner";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { Helmet } from "react-helmet-async";
export default function Career() {
  return (
    <>
    <Helmet>
  <title>Legal Careers in Delhi NCR | Join R & P Law Partners</title>

  <meta
    name="description"
    content="Build your legal career with R & P Law Partners in Delhi NCR and work alongside experienced professionals delivering exceptional legal services."
  />

  <meta
    name="keywords"
    content="Career"
  />

  <link
    rel="canonical"
    href="https://rplawpartners.com/careers "
  />

  <noscript>
    Please enable JavaScript to view this page properly.
  </noscript>
</Helmet>

      <Header />
      <PageBanner
        title="Join Our Team"
        subtitle="Empowering the Next Generation of Legal Minds"
      />
      <CareerSection />
      <Footer />
    </>
  );
}
